import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Variant-D-only marketing hero. Rendered as the dark split panel on desktop
 * (rosie logo, headline, sub-headline, and three stat pills) and collapses to a
 * light-purple logo header band on mobile. Shared by the onboarding-hosted
 * signup flow and the standalone complete-signup page so both surfaces render
 * the exact same panel.
 */
@Component({
  selector: 'rosie-variant-d-hero',
  templateUrl: './variant-d-hero.component.html',
  styleUrls: ['./variant-d-hero.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class VariantDHeroComponent {
  readonly stats = [
    { icon: 'assets/images/vd-stat-calls.svg', value: '3.1m+', label: 'Calls' },
    { icon: 'assets/images/vd-stat-texts.svg', value: '210k+', label: 'Texts' },
    { icon: 'assets/images/vd-stat-appointments.svg', value: '35k+', label: 'Appointments' }
  ];
}
